import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Button, Table, Container } from 'react-bootstrap';

import PageTitle from '../../../common/PageTitle';

class Company extends Component {

  render() {
    const addRole = <Button id="add-client" size="md" onClick={() => {
        this.props.history.push('/settings/company/add')
    }}>Add Company</Button>

    return (
      <div>
        <Container className="waa-container">
            <PageTitle pageName="COMPANY" actionButton={addRole} />
            <Row>
                <Table className="waa-table">
                    <thead>
                        <tr>
                            <th>COMPANY NAME</th>
                            <th>PARENT COMPANY</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Ayala Corporation</td>
                            <td>None</td>
                        </tr>
                        <tr>
                            <td>HCX Technology Partner, Inc.</td>
                            <td>Ayala Corporation</td>
                        </tr>
                        <tr>
                            <td>Bank of the Philippine Islands</td>
                            <td>None</td>
                        </tr>
                    </tbody>
                </Table>
            </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
})

export default withRouter(connect(mapStateToProps)(Company))